import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  DisplayService,
  LogService,
  Session,
} from 'src/app/my-sedgwick';
import { BaseComponent, SelectOption } from 'src/app/shared';
import { clients } from 'src/app/shared/models/user';
import { UserDetails } from '../../services/userdetails.service';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-preview-mode-header',
    template: `
    <div class="preview-mode">
      <div class="tw-block md:tw-hidden">
        <mat-toolbar class="header-xs" style="z-index:999">
          <div class="tw-flex tw-w-full md:tw-w-1/4">
            <app-logos></app-logos>
          </div>
        </mat-toolbar>
      </div>
    
      <mat-toolbar
        color="primary"
        class="header fixtoolbar last-head-bar"
        [class.mat-elevation-z4]="scrolled"
        style="z-index:999"
        >
        <div class="md:tw-w-[23%] tw-w-full">
          @if (logoImage) {
            <img
              src="data:image/JPEG;base64,{{ logoImage }}"
              alt="'mySedgwick Logo' | translation: translationRequest"
              tabindex="0"
              [attr.aria-label]="'mySedgwick Logo' | translation: translationRequest"
              class="tw-hidden md:tw-block"
              />
          }
        </div>
        @if (
          (isInternalAuditor && accessclients.length === 0) ||
          accessclients.length === 1
          ) {
          <div
            class=""
            >
            {{ 'Client' | translation: translationRequest }} : {{ clientHeader }}
          </div>
        }
        @if (isInternalAuditor && accessclients.length > 1) {
          <div
            class="md:tw-w-[40%] tw-w-full"
            >
            <form [formGroup]="formGroup" class="tw-flex tw-flex-wrap">
              <span class="tw-hidden md:tw-block app-pt2 app-pl2">
                {{ 'Clients' | translation: translationRequest }} : &nbsp;
              </span>
              <app-select-control
                formControlName="clients"
                label="Select client"
                [formGroup]="formGroup"
                [options]="accessclients"
                ngDefaultControl
                class="md:tw-w-[80%] tw-w-full"
                [className]="'app-pt1'"
                [translationNeeded]="false"
                />
              </form>
            </div>
          }
          @if (session.user.emulatorContext.role === 'AUDITOR') {
            <app-preview-mode
              [translationRequest]="translationRequest"
            ></app-preview-mode>
          }
          <span class="example-spacer"></span>
    
          <mat-icon class="app-icon persondisplay">person</mat-icon>
          <div
            class="app-pr3 app-pl1 tw-font-bold tw-text-[var(--sed-black-80-color)]"
            >
            {{ session.user.emulatorContext.firstName }}
          </div>
          <div class="md:tw-block">
            <button
              title="Home"
              [attr.aria-label]="'Home' | translation: translationRequest"
              mat-icon-button
              (click)="redirectToHome()"
              >
              <mat-icon class="app-icon">home</mat-icon>
            </button>
          </div>
          <div class="md:tw-block">
            @if (showSearch) {
              <app-overlay [origin]="searchOverlayOrigin" #searchOverlay>
                @if (searchOverlay.opened) {
                  <app-quick-search
                    [showTitle]="false"
                    class="overlay"
                  ></app-quick-search>
                }
              </app-overlay>
              <button
                [title]="'Search' | translation: translationRequest"
                [attr.aria-label]="'Search Popup' | translation: translationRequest"
                mat-icon-button
                cdkOverlayOrigin
                #searchOverlayOrigin="cdkOverlayOrigin"
                (click)="searchOverlay.open()"
                >
                <mat-icon class="app-icon">search</mat-icon>
              </button>
            }
          </div>
          <div class="md:tw-block">
            @if (!isPreference) {
              <button
                [attr.aria-label]="'Account settings' | translation: translationRequest"
                role="link"
                mat-icon-button
                (click)="this.auditorAccountSettings()"
                (keydown.enter)="this.auditorAccountSettings()"
                >
                <mat-icon class="app-icon">settings</mat-icon>
              </button>
            }
          </div>
          <div class="md:tw-block">
            <button
              mat-button
              class="logout app-icon"
              [attr.aria-label]="'Logout and open the login page' | translation: translationRequest"
              (click)="logOut()"
              (keydown.enter)="logOut()"
              >
              <b>{{ 'Log out' | translation: translationRequest }}</b>
            </button>
          </div>
        </mat-toolbar>
      </div>
    `,
    styles: [
        `
      .overlay h2 {
        padding-top: 20px;
      }

      .mat-mdc-toolbar.mat-mdc-primary {
        position: sticky;
        top: 0;
        z-index: 1;
        min-height: 64px;
      }

      .example-spacer {
        flex: 1 1 auto;
      }

      .mat-mdc-toolbar {
        position: relative;
      }
      .overlay {
        width: 600px;
      }
      .header {
        background-color: #ffffff;
        color: #67707a;
        border-bottom: 1px solid #e0e0e0;
      }
      .header-xs {
        background-color: #ffffff;
      }

      .last-head-bar {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
      }
      .mat-toolbar-row,
      .mat-toolbar-single-row {
        min-height: 64px;
        height: auto !important;
      }

      @media only screen and (max-device-width: 480px) {
        .persondisplay {
          overflow: visible !important;
        }

        .fixtoolbar {
          position: sticky;
          top: 0;
          z-index: 999999999;
          min-height: 64px;
        }
      }
      .preview-mode {
        z-index: 9999;
      }
    `,
    ],
    standalone: false
})
export class PreviewModeHeaderComponent
  extends BaseComponent
  implements OnInit
{
  scrolled = false;
  isPreference = false;
  showSearch = true;
  isInternalAuditor = false;
  accessclients: SelectOption[] = [];
  private auditorClients: clients[] = [];
  clientHeader: string;

  logoImage: string;
  @Output() logOutEmitter = new EventEmitter();

  @Input()
  translationRequest: TranslationRequest;

  formGroup: FormGroup = this.fb.group({
    clients: [],
  });
  constructor(
    public session: Session,
    public userdetails: UserDetails,
    public dialog: MatDialog,
    public logService: LogService,
    private router: Router,
    public display: DisplayService,
    private fb: UntypedFormBuilder
  ) {
    super();
  }

  async ngOnInit() {
    !this.session.user ? await this.session.loadUser() : null;
    this.refreshValues();
    const dataLogo = await this.session.GetLogoDetails();
    if (dataLogo != undefined) {
      this.logoImage = dataLogo.clientLogoImg;
    }

    await this.getAccessClients();

    this.clientHeader = this.session.clientHeader;

    if (this.accessclients.length > 0 && this.session.SelectedContNum != '-1') {
      this.formGroup.controls['clients'].setValue(
        this.session.SelectedContNum,
        this.accessclients
      );
    }

    this.formGroup.controls['clients'].valueChanges.subscribe((value) => {
      if (value && value > -1 && value != this.session.SelectedContNum) {
        const selected = this.auditorClients.find(
          (client) => client.contNum === value
        );

        if (!selected) {
          return;
        }

        this.session.SetUpdatedClient(value, selected.clientName);
        this.logOutEmitter.emit();
      }
    });
    this.session.selectClient$.subscribe((value) => {
      if (this.session.user.isEmulating) {
        const clientData = this.accessclients.filter(
          (item) => item.value === value
        );
        const selected = this.auditorClients.find(
          (client) => client.contNum === clientData[0].value
        );
        this.session.SetSelectedClient(
          clientData[0].value,
          selected?.clientName ?? clientData[0].label
        );
        this.formGroup.controls['clients'].setValue(value);
      }
    });
  }

  async getAccessClients() {
    const opts = await this.session.getInternalAuditorClientsList();
    this.auditorClients = opts;
    const opts1 = opts.map((r) => {
      return {
        label: r.clientName + ' - ' + r.contNum,
        value: r.contNum,
      } as SelectOption;
    });

    this.accessclients = opts1;
    if (opts1.length == 1) {
      this.session.SetSelectedClient(opts[0].contNum, opts[0].clientName);
    }
  }

  refreshValues() {
    this.isInternalAuditor =
      this.session.user.emulatorContext.userType === 'INTERNALAUDITOR';
    this.showSearch = false;
  }

  async auditorAccountSettings() {
    if (this.session.isEmulating$) {
      await this.session.stopEmulation('/PreferencesPage');
    } else {
      this.router.navigate(['/']);
    }
  }

  async logOut() {
    await this.session.logoff();
  }
  async redirectToHome() {
    if (this.session.user.isEmulating) {
      await this.session.stopEmulation('/');
    } else {
      this.router.navigate(['/']);
    }
  }
}
